import { SxProps } from '@mui/system';
import useMediaQuery from '@mui/system/useMediaQuery';
import React from 'react';
import { Box } from 'src/components/Box';
import { Stack } from 'src/components/Stack';
import { Typography } from 'src/components/Typography';

import { Divider } from './Divider';
import { Theme } from './muiTheme/types';

interface SectionHeaderProps {
  title: React.ReactNode;
  titleAdornment?: React.ReactNode;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
  bottomDivider?: boolean;
  topDivider?: boolean;
  sx?: SxProps;
}
export const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  titleAdornment,
  subtitle,
  actions,
  bottomDivider,
  topDivider,
  sx,
  ...props
}) => {
  const smDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  return (
    <>
      {topDivider && <Divider />}
      <Stack
        direction={smDown ? 'column' : 'row'}
        alignItems={smDown ? 'flex-start' : 'center'}
        justifyContent={smDown ? 'center' : 'space-between'}
        spacing={2}
        sx={[{ p: 2, minHeight: '70px' }, ...(Array.isArray(sx) ? sx : [sx])]}
        {...props}
      >
        <Box sx={{ width: '100%' }}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <Typography variant="h6" gutterBottom={!!subtitle}>
              {title}
            </Typography>
            {!!titleAdornment && titleAdornment}
          </Stack>
          {subtitle && (
            <Typography variant="body2" color="text.secondary">
              {subtitle}
            </Typography>
          )}
        </Box>
        {!!actions && (
          <Stack
            direction="row"
            alignItems="center"
            spacing={1}
            sx={{ flex: '0 0 auto' }}
          >
            {actions}
          </Stack>
        )}
      </Stack>
      {bottomDivider && <Divider />}
    </>
  );
};
